import Cookies from 'universal-cookie';
import { updateUserProfile, setAppState, toggleTheme } from '../actions'
export default class Auth {


    constructor(history) {
    this.history = history;
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    }



    login() {
        localStorage.removeItem('user_type');
         //Clear access token and ID token from local storage
        localStorage.removeItem('access_token');
        localStorage.removeItem('expires_at');
        this.history.push('/login')
        return false;
  }


    logInCallback2(data, history) {
        
        
        var store = window.store;
        
        store.dispatch(updateUserProfile(data.userProfileModel))
        store.dispatch(setAppState(data.clientViewModel))

        const cookies = new Cookies();
        let t = cookies.get('theme');
        t = t ? t : "light"
        store.dispatch(toggleTheme(t));

        localStorage.setItem('last_facility', data.userProfileModel.lastFacilityId);


        const redirectLocation = localStorage.getItem("REDIRECT_ON_LOGIN") === 'undefined' ? null : JSON.parse(localStorage.getItem("REDIRECT_ON_LOGIN"));
        localStorage.setItem('user_type', data.userProfileModel.userType);
        //User logs in
        //Check if user has more than one product
        //if so check the last selected product cookie
        //else take them to the one they are on.
        //Select the first facility in that product

        //if owner check use product facilites -- doesnt have to have a facility assigned to them
        if (redirectLocation && redirectLocation.indexOf('logout') == -1 && redirectLocation.indexOf('callback') == -1) {
            history.push(redirectLocation)
        } else if (data.userProfileModel.userType == "3") {
            
            history.push('/scheduler/my-schedule')
        } else {
            history.push('/scheduler/overview')
        }
    }

    logoutTimeClock(url) {
        localStorage.removeItem("REDIRECT_ON_LOGIN")
        // Clear access token and ID token from local storage
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        localStorage.removeItem('refresh_token');
        window.location.href = url;
    }

  logout() {
    
      localStorage.removeItem("REDIRECT_ON_LOGIN")
      
      // Clear access token and ID token from local storage
      localStorage.removeItem('access_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('refresh_token');

      localStorage.removeItem('expires_at');
      window.location.href = "/login";
    // navigate to the home route
     // location.href = 'https://ertools.auth0.com/v2/logout?returnTo=https://ertools.auth0.com/login&client_id=gi7QmgxRUN139eNwOw6gkqvpWaetzbey'
      //this.login();
    }

    parseJwt = (token) => {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    };

    isAuthenticated2() {
        // Check whether the current time is past the 
        // access token's expiry time
        let expiresAt = new Date(localStorage.getItem('expires_at'));
        let isAuthed = new Date().getTime() < expiresAt;
        if (isAuthed && localStorage.getItem("access_token")) {
            return true;
        }
        return false;
    }

  isAuthenticated() {
    // Check whether the current time is past the 
    // access token's expiry time
      let expiresAt = new Date(localStorage.getItem('expires_at'));
      let isAuthed = new Date().getTime() < expiresAt;
      if (!isAuthed && window.location.pathname.indexOf('login') === -1 && window.location.pathname.indexOf('signup') === -1) {
          //localStorage.setItem("REDIRECT_ON_LOGIN", JSON.stringify(window.location.pathname))
      }
      return isAuthed;
  }
}



